import React from 'react';
import { Input } from 'reactstrap';

export interface TermsFormSelectProps {
    value: string;
    options: readonly { value: string; label?: string }[];
    onChange: (value: string | null) => void;
    disabled?: boolean;
    invalid?: boolean;
    className?: string;
    'aria-label': string;
}

export const TermsFormSelect: React.FC<TermsFormSelectProps> = ({
    value,
    options,
    onChange,
    disabled,
    invalid,
    className,
    'aria-label': ariaLabel,
}) => (
    <Input
        type="select"
        value={value}
        disabled={disabled}
        invalid={invalid}
        onChange={(e) => onChange(e.target.value === '' ? null : e.target.value)}
        className={`form-control loi-form-input${className ? ` ${className}` : ''}`}
        aria-label={ariaLabel}>
        <option value="" />
        {options.map((opt) => (
            <option key={opt.value} value={opt.value}>
                {opt.label ?? opt.value}
            </option>
        ))}
    </Input>
);
